<template>
    <div class="container-fluid">
        <Breadcrumb title="Campaigns Report" v-bind:button-show="false"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group">
                            <label>Campaign type</label>
                            <treeselect placeholder="PMTA" :disabled="true"
                                :multiple="false" :searchable="false" :options="campaignTypeList" />
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12">
                                <label for="offerName">Offer Name</label>
                                <input v-model="filter.offerName" type="text" class="form-control" id="offerName"
                                    name="offerName">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12">
                                <label for="offerName">Email List Name</label>
                                <input v-model="filter.emailListName" type="text" class="form-control"
                                    id="emailListName" name="emailListName">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12">
                                <label for="offerName">Campaign Name</label>
                                <input v-model="filter.campaignName" type="text" class="form-control" id="campaignName"
                                    name="camapignName">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-2">
                                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light w-100"
                                    @click="getReport()">
                                    Get
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{ preloader: loading }"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="report.length <= 1">{{ emptyMessage }}</div>
                            <div v-else>
                                <div>
                                    <div class="table-responsive">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th @click="tableOrdering('campaign.id')">
                                                        <span role='button'>ID</span>
                                                    </th>
                                                    <th @click="tableOrdering('campaign.name')">
                                                        <span role='button'>Name</span>
                                                    </th>
                                                    <th>
                                                        <span role='button'>Email List</span>
                                                    </th>
                                                    <th>
                                                        <span role='button'>Offer</span>
                                                    </th>
                                                    <th>
                                                        <span role='button'>Delivered</span>
                                                    </th>
                                                    <th>
                                                        <span role='button'>Bounced</span>
                                                    </th>
                                                    <th>
                                                        <span role='button'>Open</span>
                                                    </th>
                                                    <th>
                                                        <span role='button'>Click</span>
                                                    </th>
                                                    <th>
                                                        <span role='button'>Conv</span>
                                                    </th>
                                                    <th>
                                                        <span role='button'>Profit({{ adminStyle ? 'Gross' : 'Net' }})</span>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(row, index) in report" :key="index">
                                                    <td class="align-middle">{{ row.campaignId }}</td>
                                                    <td class="align-middle">{{ row.campaignName }}</td>
                                                    <td class="align-middle">{{ row.emailListName }}</td>
                                                    <td class="align-middle">{{ row.offerName }}</td>
                                                    <td class="align-middle">{{ row.delivered }}</td>
                                                    <td class="align-middle">{{ row.bounced }}</td>
                                                    <td class="align-middle">{{ row.view }}</td>
                                                    <td class="align-middle">{{ row.click }}</td>
                                                    <td class="align-middle">{{ row.convCount }}</td>
                                                    <td class="align-middle" v-tooltip.top="'Average=' + (((adminStyle ? (row.profitGross/row.convCount || 0): (row.profitNet/row.convCount || 0)))/100).toFixed(2)">
                                                        {{ ((adminStyle ? row.profitGross : row.profitNet)/100).toFixed(2) }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <paginate v-if="report.length >= 1" v-model="filter.page" :page-count="getPageCount"
                                :page-range="3" :margin-pages="2" :click-handler="getReport" :prev-text="'Prev'"
                                :next-text="'Next'" :container-class="'mt-2 pagination justify-content-center'"
                                :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'"
                                :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'">
                            </paginate>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import Swal from 'sweetalert2'
import Preloader from '../components/Preloader';
import Breadcrumb from '../components/Breadcrumb';
import ReportService from '../services/ReportService';
import { CampaignType } from '../constants';
import DatePicker from 'vue2-datepicker';

export default {
    name: 'ProfitReport',
    components: {
        Treeselect,
        Breadcrumb,
        Preloader,
        DatePicker
    },
    data() {
        return {
            report: [],
            campaignsCount: 0,
            adminStyle: false,
            emptyMessage: '',
            filter: {
                campaignType: 'PMTA',
                campaignName: null,
                emailListName: null,
                offerName: null,
                orderBy: 'campaign.id',
                orderDirection: 'DESC',
                perPage: 100,
                page: 1
            },
            campaignTypeList: CampaignType.select,
            loading: false,
        }
    },
    mounted() {
    },
    methods: {
        getReport: function () {
            this.loading = true;
            ReportService.getCampaignReport(JSON.stringify(this.filter)).then(response => {
                if (response.status !== 200) {
                    Swal({
                        type: 'error',
                        title: 'Error',
                        text: (response.data.error === undefined) ? response.status + ': ' + response.statusText : response.data.error[0]
                    });
                    this.loading = false;
                    return;
                }
                this.report = response.data.report;
                this.adminStyle = response.data.admin;
                this.campaignsCount = response.data.campaignsCount;
                this.emptyMessage = 'No data found.';
                this.loading = false;
            }).catch(error => {
                Swal({
                    type: 'error',
                    title: 'Oops...',
                    text: `${error}`,
                });
                this.loading = false;
            });
        },
        tableOrdering(field) {
            if (this.filter.orderBy === field) {
                this.filter.orderDirection = (this.filter.orderDirection === 'DESC' ? 'ASC' : 'DESC');
            } else {
                this.filter.orderBy = field;
                this.filter.orderDirection = 'DESC';
            }
            this.getReport();
        },
        getCampaignType(type) {
            return CampaignType.value[type];
        }
    },
    computed: {
        getPageCount: function () {
            return Math.ceil(this.campaignsCount / this.filter.perPage);
        },
    }
}
</script>

<style scoped>
tbody {
    font-size: 14px;
    font-family: Arial, serif;
}
</style>
